/**
 * @desc 运费测算
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<Array<defs.tms.FreightResponseDto>>;
export function request(body: defs.tms.LogisticsMatchTestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsChannel/test/freightEstimate`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
